import { render } from "./SectionElement.vue?vue&type=template&id=12156cd6&scoped=true"
import script from "./SectionElement.vue?vue&type=script&lang=js"
export * from "./SectionElement.vue?vue&type=script&lang=js"

import "./SectionElement.vue?vue&type=style&index=0&id=12156cd6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12156cd6"]])

export default __exports__